import * as React from 'react'

import {
  SwatchSelectSliderSet,
  SwatchSelectSlider,
} from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  SwatchSelectorSliderSet,
  SwatchSelectorSliderSetProps,
  SwatchSelectorSliderItemProps,
} from '@thg-commerce/enterprise-widget-swatch-selector-slider-set'
import { styled, spacing } from '@thg-commerce/enterprise-theme'

export interface SwatchSelectorSliderWidgetRendererProps
  extends Omit<SwatchSelectSliderSet, 'banners' | 'query' | 'id'> {
  banners?: Omit<SwatchSelectSlider, 'query' | 'id'>[]
  title?: string
  subtitle?: string
}

const NUMBER_OF_ITEMS = ['One', 'Two', 'Three', 'Four']

const StyledSwatchSelectorSliderSet = styled(SwatchSelectorSliderSet)`
  margin: 0 auto;
  padding: ${spacing(1)} ${spacing(2)};
  max-width: ${(props) => props.theme.site.siteWidth};
`

export const SwatchSelectorSliderWidgetRenderer = (
  props: SwatchSelectorSliderWidgetRendererProps,
) => {
  if (!props.banners?.length) {
    return null
  }

  const swatchSelectorSliderItems: SwatchSelectorSliderSetProps = {
    title: props.title || undefined,
    subtitle: props.subtitle || undefined,
    items: props.banners
      .map(
        (banner) =>
          banner && {
            CTA:
              banner.cta && banner.ctaLink
                ? {
                    text: banner.cta,
                    link: banner.ctaLink,
                  }
                : undefined,
            extraCTA:
              banner.link && banner.linkText
                ? {
                    text: banner.linkText,
                    link: banner.link,
                  }
                : undefined,
            count: banner.count || undefined,
            logoImage: {
              src: [
                {
                  url: banner.logoImagePath,
                },
              ],
              alt: banner.altTextLogoImage,
              width: '100%',
              height: 'auto',
              isAmp: false,
            },
            content: banner.info,
            swatches: NUMBER_OF_ITEMS.filter(
              (itemNumber) =>
                banner[`title${itemNumber}`] &&
                banner[`thumbnailImage${itemNumber}Path`] &&
                banner[`altTextThumbnailImage${itemNumber}`] &&
                banner[`image${itemNumber}Link`] &&
                banner[`image${itemNumber}Path`] &&
                banner[`altTextImage${itemNumber}`],
            ).map((itemNumber) => ({
              title: banner[`title${itemNumber}`],
              thumbnail: {
                src: [
                  {
                    url: banner[`thumbnailImage${itemNumber}Path`],
                  },
                ],
                alt: banner[`altTextThumbnailImage${itemNumber}`],
                width: '100%',
                height: 'auto',
                isAmp: false,
              },
              image: {
                src: [
                  {
                    url: banner[`image${itemNumber}Path`],
                  },
                ],
                alt: banner[`altTextImage${itemNumber}`],
                width: '100%',
                height: 'auto',
                isAmp: false,
                link: banner[`image${itemNumber}Link`],
              },
            })),
          },
      )
      .filter(
        (item) => item.swatches.length,
      ) as SwatchSelectorSliderItemProps[],
  }

  return <StyledSwatchSelectorSliderSet {...swatchSelectorSliderItems} />
}
